<script>
  import { Doughnut } from 'vue-chartjs'

  export default {
    extends: Doughnut,
    props: {
      data: {
        type: Array,
        required: true
      },
      labels: {
        type: Array,
        required: true
      }
    },
    mounted () {
      this.renderChart({
        datasets: [{
          data: this.data,
          backgroundColor: this.getColors()
        }],
        labels: this.labels
      })
    }
  }
</script>
